import React from 'react'
import BookingPaymentSuccessState from './BookingPaymentSuccessState'
import MemberBookingSuccess from '../components/MemberBookingSuccess'

export default function MemberFitnessBookingSuccessPage({ clubCode }) {
  return <BookingPaymentSuccessState clubCode={clubCode} module="fitness">
    <MemberBookingSuccess clubCode={clubCode} module="fitness" />
  </BookingPaymentSuccessState>
}
